import { useEffect, useRef, useState } from 'react';
import { Plus } from 'lucide-react';
import EmojiPicker from '@emoji-mart/react';
import data from '@emoji-mart/data';

const QUICK_EMOJIS = ['❤️', '🔥', '😂', '👀', '💀', '✨'];

interface ReactionPickerProps {
  onPick: (emoji: string) => void;
  onClose: () => void;
}

export function ReactionPicker({ onPick, onClose }: ReactionPickerProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [fullPicker, setFullPicker] = useState(false);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    }
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        if (fullPicker) setFullPicker(false);
        else onClose();
      }
    }
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [onClose, fullPicker]);

  function handleEmojiSelect(emoji: { native: string }) {
    onPick(emoji.native);
  }

  return (
    <div className="reaction-picker-container" ref={ref}>
      {fullPicker ? (
        <div className="reaction-picker-full">
          <EmojiPicker
            data={data}
            onEmojiSelect={handleEmojiSelect}
            theme="dark"
            previewPosition="none"
            skinTonePosition="search"
            maxFrequentRows={2}
            navPosition="bottom"
            perLine={8}
          />
        </div>
      ) : (
        <div className="reaction-picker">
          {QUICK_EMOJIS.map(emoji => (
            <button
              key={emoji}
              className="reaction-picker__btn"
              onClick={() => onPick(emoji)}
              aria-label={`React with ${emoji}`}
            >
              {emoji}
            </button>
          ))}
          <button
            className="reaction-picker__btn reaction-picker__plus"
            onClick={() => setFullPicker(true)}
            aria-label="Browse all emojis"
          >
            <Plus size={16} />
          </button>
        </div>
      )}
    </div>
  );
}
